import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export enum States {
  ILLINOIS = 'Illinois',
  NEBRASKA = 'Nebraska',
}

interface CurrentState {
  currentStateName: string | undefined
  currentStateId: number | undefined
  setCurrentState: (stateName: string, stateId: number) => void
}

export const useCurrentStateStore = create<CurrentState>()(
  persist(
    (set) => ({
      // defaulting to Illinois for now
      currentStateName: States.ILLINOIS,
      currentStateId: 1,
      setCurrentState: (stateName: string, stateId: number) =>
        set({
          currentStateName: stateName,
          currentStateId: stateId,
        }),
    }),
    {
      name: 'current-state',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
